import { Link } from "react-router-dom";
import { useDataFastGoals } from "@/hooks/useDataFastGoals";
import { useSectionViewGoal } from "@/hooks/useSectionViewGoal";
import { buttonClass, CONTAINER } from "./ui-tokens";
import WhatsAppCTA from "./WhatsAppCTA";
import { FounderSignature } from "./founder";

export default function FinalCta() {
  const { trackNavClicked, trackWhatsappClicked } = useDataFastGoals();
  const ref = useSectionViewGoal("final_cta");

  return (
    <section
      ref={ref}
      id="comecar"
      aria-labelledby="comecar-titulo"
      className="bg-lp-band text-lp-band-foreground"
    >
      <div className={`${CONTAINER} py-20 md:py-28`}>
        <div className="lp-reveal max-w-3xl">
          <h2
            id="comecar-titulo"
            className="text-3xl leading-[1.1] font-semibold tracking-tight text-balance md:text-5xl"
          >
            No próximo domingo, a sua igreja já pode estar organizada.
          </h2>

          {/* "se você não amar a transformação na sua rotina" era a única frase
              de infoproduto numa página de tom sóbrio — e justamente no
              parágrafo que fala de devolver dinheiro, onde a credibilidade
              importa mais. */}
          <p className="mt-6 max-w-2xl text-base leading-relaxed text-pretty text-lp-band-foreground/75 md:text-lg">
            Crie a conta hoje. Nossa equipe implanta e migra os dados de graça em
            até 72h, e se nos 7 dias depois da primeira cobrança a rotina da
            igreja não tiver mudado, devolvemos 100% do valor pago. Sem
            fidelidade.
          </p>

          {/* Uma pessoa assumindo a promessa, no ponto em que a dúvida é "e
              se não der certo". A história inteira está na /about. */}
          <FounderSignature tone="band" className="mt-8 max-w-2xl" />

          {/* Este botão rolava de volta para #precos. Quem chegou até aqui
              leu a página inteira: devolvê-la para cima é pedir que decida de
              novo o que já decidiu. No fim da página a dúvida é "e se não der
              certo", e é essa que o rótulo responde. */}
          <div className="mt-10 flex flex-col gap-3 sm:flex-row sm:items-center">
            <Link
              to="/register"
              onClick={() => trackNavClicked("final_cta")}
              className={buttonClass("inverse", "lg")}
            >
              Começar sem pagar nada hoje
            </Link>
            <WhatsAppCTA
              variant="glass"
              size="lg"
              text="Falar com o Vinicius"
              customMessage="Olá, Vinicius! Cheguei ao fim da página do Ecclesiato e gostaria de conversar antes de criar a conta."
              onClick={() => trackWhatsappClicked("final_cta")}
            />
          </div>

          <p className="mt-6 text-sm text-lp-band-foreground/65">
            A partir de R$ 97/mês · Implantação e migração gratuitas em até 72h ·
            Cancele quando quiser
          </p>
        </div>
      </div>
    </section>
  );
}
